// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"770fd343","422":"74eb7bfc","479":"5f638503","490":"6f8782f2","784":"8142a807","838":"396fd089","842":"ca8f9a60"}[chunkId] + ".chunk.js";
};